import { render } from "./BuPayRecord.vue?vue&type=template&id=5910ad6f&scoped=true"
import script from "./BuPayRecord.vue?vue&type=script&lang=js"
export * from "./BuPayRecord.vue?vue&type=script&lang=js"

import "./BuPayRecord.vue?vue&type=style&index=0&id=5910ad6f&scoped=true&lang=less"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5910ad6f"]])

export default __exports__